import React from "react";

function Header() {
  return (
    <header>
      <nav>
        <span className="nav-left">
          <span className="nav-title">
            <span role="img" aria-label="Hello">
              Hey 👋,
            </span>{" "}
            I'm Mulika.
          </span>
        </span>
        <span className="nav-right">
          <a
            className="nav-item nav-link"
            href="https://youtu.be/fqQmH5Ct3oI"
            target="_blank"
            rel="noopener noreferrer"
          >
            Video
          </a>
          <a
            className="nav-item nav-link"
            href="https://github.com/mayeedwin/mulika"
            target="_blank"
            rel="noopener noreferrer"
          >
            GitHub
          </a>
        </span>
      </nav>
    </header>
  );
}

export default Header;
